import { render } from "./Audience.vue?vue&type=template&id=2b3d5a40&scoped=true"
import script from "./Audience.vue?vue&type=script&lang=ts"
export * from "./Audience.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-2b3d5a40"

export default script